import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { HexColorPicker } from "react-colorful";
import styles from "./MapSettingsColorModal.module.css";
import sButtons from "../../../assets/styles/buttons.module.css";
interface Props {
  isShowModal: boolean;
  currentColor?: string;
  onClose: () => void;
  onSave: (color: string) => void;
}

export const MapSettingsColorPicker = ({ isShowModal, currentColor, onClose, onSave }: Props) => {
  const [color, setColor] = useState("#ffffff");

  useEffect(() => {
    setColor(currentColor || "#ffffff");
  }, [currentColor]);

  return (
    <Modal
        show={isShowModal}
        onHide={onClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName={styles.modalContent}
    >
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title id="contained-modal-title-vcenter">Выбор цвета</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div style={{ backgroundColor: color, height: 56, width: "100%", marginBottom: 16, borderRadius: 16 }} />
        <HexColorPicker color={color} onChange={setColor} style={{ width: "100%" }} />
      </Modal.Body>
      <div className={styles.buttonsWrapper}>
        <button onClick={onClose} className={sButtons.dangerButton}>
          Отменить
        </button>
        <button onClick={() => onSave(color)} className={sButtons.successButton}>
          Сохранить
        </button>
      </div>
    </Modal>
  );
};
